import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { legalContent, LegalPageKey } from '../i18n/legalContent';
import './LegalPage.css';

type LegalPageProps = {
  page: LegalPageKey;
};

const LegalPage: React.FC<LegalPageProps> = ({ page }) => {
  const { language } = useLanguage();
  const content = legalContent[language][page];

  useEffect(() => {
    document.title = `${content.title} | SOLTEC`;
  }, [content.title]);

  if (!content) {
    return <Navigate to="/" replace />;
  }

  return (
    <article className="legal-page editorial-section">
      <div className="editorial-container">
        <header className="legal-page-header">
          <h1 className="legal-page-title">{content.title}</h1>
          <p className="legal-page-updated">{content.lastUpdated}</p>
          <p className="legal-page-intro">{content.intro}</p>
        </header>

        <div className="legal-page-body">
          {content.sections.map((section) => (
            <section key={section.title} className="legal-page-section">
              <h2>{section.title}</h2>
              {section.paragraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </section>
          ))}
        </div>
      </div>
    </article>
  );
};

export default LegalPage;
